// extracted by mini-css-extract-plugin
export var arrow = "EditUserCollectionModal-module--arrow--40bc0";
export var arrowNo = "EditUserCollectionModal-module--arrow_no--4e881";
export var arrowYes = "EditUserCollectionModal-module--arrow_yes--b54ca";
export var checkbox = "EditUserCollectionModal-module--checkbox--fee81";
export var checkboxDescription = "EditUserCollectionModal-module--checkboxDescription--224a4";
export var coverImage = "EditUserCollectionModal-module--coverImage--27a2f";
export var flex = "EditUserCollectionModal-module--flex--99913";
export var flex1 = "EditUserCollectionModal-module--flex_1--1f8fc";
export var flexCenter = "EditUserCollectionModal-module--flex_center--1c22b";
export var flexCenterCol = "EditUserCollectionModal-module--flex_center_col--dbdde";
export var flexCol = "EditUserCollectionModal-module--flex_col--2801c";
export var flexFixCenterCol = "EditUserCollectionModal-module--flex_fix_center_col--1b5af";
export var flexFixedCenterCol = "EditUserCollectionModal-module--flex_fixed_center_col--f262d";
export var input = "EditUserCollectionModal-module--input--ff993";
export var padding = "EditUserCollectionModal-module--padding--1cd68";
export var rotating = "EditUserCollectionModal-module--rotating--50ca0";
export var submitButton = "EditUserCollectionModal-module--submitButton--2ccfb";
export var title = "EditUserCollectionModal-module--title--45828";
export var wrapper = "EditUserCollectionModal-module--wrapper--bb38b";